interface ISpinner {
    colour?: string
}

export default function Spinner({colour}:ISpinner) {
    return <div className={`spinner spinner--${colour}`}></div>
}